export enum Location {
    'Pryor Street' = 'PRYOR_STREET',
}

export enum Type {
    "Rapid Rehousing" = "RAPID_REHOUSING",
    "Permanent Supportive Housing" = "PERMANENT_SUPPORTIVE_HOUSING"
}